import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";

// Configurations
import { organizationSlice } from "../app/modules/Configurations/_redux/organizations/organizationSlice";
import { locationSlice } from "../app/modules/Configurations/_redux/locations/locationSlice";
import { warehouseSlice } from "../app/modules/Configurations/_redux/warehouses/warehouseSlice";
import { bintypeSlice } from "../app/modules/Configurations/_redux/bintypes/bintypeSlice";
import { binSlice } from "../app/modules/Configurations/_redux/bins/binSlice";
import { itemtypeSlice } from "../app/modules/Configurations/_redux/itemtypes/itemtypeSlice";
import { itemSlice } from "../app/modules/Configurations/_redux/items/itemSlice";
import { merchantSlice } from "../app/modules/Configurations/_redux/merchants/merchantSlice";
import { merchantitemSlice } from "../app/modules/Configurations/_redux/merchantitems/merchantitemSlice";
import { storeSlice } from "../app/modules/Configurations/_redux/stores/storeSlice";
import { storeItemSlice } from "../app/modules/Configurations/_redux/storeItems/storeItemSlice";
import { transporterSlice } from "../app/modules/Configurations/_redux/transporters/transporterSlice";
import { dishwasherSlice } from "../app/modules/Configurations/_redux/dishwashers/dishwasherSlice";
import { usersSlice } from "../app/modules/Configurations/_redux/users/userSlice";
import { companySlice } from "../app/modules/Configurations/_redux/companies/companySlice";
import { matrixTypeSlice } from "../app/modules/Configurations/_redux/matrix-type/matrixTypeSlice";

// Accounting
import { cashflowSlice } from "../app/modules/Accounting/_redux/cashflows/cashflowSlice";
import { productSlice } from "../app/modules/Accounting/_redux/products/productSlice";
import { linkSlice } from "../app/modules/Accounting/_redux/links/linkSlice";
import { bonusSlice } from "../app/modules/Accounting/_redux/bonuses/bonusSlice";
import { cashFlowSubscriptionSlice } from "../app/modules/Accounting/_redux/cashFlowSubscriptions/cashFlowSubscriptionSlice";
// Transactions
import { inventorySlice } from "../app/modules/Transactions/_redux/inventories/inventorySlice";
import { inventoryStatusSlice } from "../app/modules/Transactions/_redux/inventoryStatus/inventoryStatusSlice";
import { storeApprovalSlice } from "../app/modules/Transactions/_redux/storeApprovals/storeApprovalSlice";
import { storeItemApprovalSlice } from "../app/modules/Transactions/_redux/storeItemApprovals/storeItemApprovalSlice";
import { stockAuditSlice } from "../app/modules/Transactions/StockAudits/_redux/stockAudits/stockAuditSlice";
import { stockAuditItemSlice } from "../app/modules/Transactions/StockAudits/_redux/stockAuditItems/stockAuditItemSlice";
import { borrowSlice } from "../app/modules/Transactions/_redux/borrows/borrowSlice";
import { reservationSlice } from "../app/modules/Transactions/_redux/reservations/reservationSlice";
// Admin
import { permissionSlice } from "../app/modules/Admin/_redux/permissions/permissionSlice";
import { permissionSetSlice } from "../app/modules/Admin/_redux/permissionSets/permissionSetSlice";
import { subAccountTypeSlice } from "../app/modules/Admin/_redux/subAccountTypes/subAccountTypeSlice";

// Admin Dashboard
import { adminDashboardSlice } from "../app/modules/Dashboard/_redux/adminDashboard/adminDashboardSlice";

// Reports

import { slice as inventoryReportSlice } from "../app/modules/Reports/_redux/inventory/slice";
import { slice as inventorySummaryReportSlice } from "../app/modules/Reports/_redux/inventory-summary/slice";
import { slice as usersReportSlice } from "../app/modules/Reports/_redux/users/slice";
import { slice as salesReportSlice } from "../app/modules/Reports/_redux/sales/slice";
import { slice as transactionsReportSlice } from "../app/modules/Reports/_redux/transactions/slice";
import { slice as merchantStoresReportSlice } from "../app/modules/Reports/_redux/merchant-stores/slice";
import { slice as merchantStoreSummaryReportSlice } from "../app/modules/Reports/_redux/merchant-store-summary/slice";
import { slice as inventoryTransactionReportSlice } from "../app/modules/Reports/_redux/inventory-transaction/slice";

const appReducer = combineReducers({
  // Auth
  auth: auth.reducer,

  // Configurations
  organizations: organizationSlice.reducer,
  locations: locationSlice.reducer,
  warehouses: warehouseSlice.reducer,
  bintypes: bintypeSlice.reducer,
  bins: binSlice.reducer,
  itemtypes: itemtypeSlice.reducer,
  items: itemSlice.reducer,
  merchants: merchantSlice.reducer,
  merchantitems: merchantitemSlice.reducer,
  stores: storeSlice.reducer,
  storeItems: storeItemSlice.reducer,
  transporters: transporterSlice.reducer,
  dishwashers: dishwasherSlice.reducer,
  users: usersSlice.reducer,
  companies: companySlice.reducer,
  matrixTypes: matrixTypeSlice.reducer,

  // Transactions
  inventories: inventorySlice.reducer,
  inventorystatus: inventoryStatusSlice.reducer,
  storeApprovals: storeApprovalSlice.reducer,
  storeItemApprovals: storeItemApprovalSlice.reducer,
  stockAudits: stockAuditSlice.reducer,
  stockAuditItems: stockAuditItemSlice.reducer,
  borrows: borrowSlice.reducer,
  reservations: reservationSlice.reducer,

  // Accounting
  cashflows: cashflowSlice.reducer,
  products: productSlice.reducer,
  links: linkSlice.reducer,
  bonuses: bonusSlice.reducer,
  cashFlowSubscriptions: cashFlowSubscriptionSlice.reducer,

  // Admin
  permissions: permissionSlice.reducer,
  permissionSets: permissionSetSlice.reducer,
  subAccountTypes: subAccountTypeSlice.reducer,

  // Admin Dashboard
  adminDashboards: adminDashboardSlice.reducer,

  // Reports
  inventoryReports: inventoryReportSlice.reducer,
  inventorySummaryReports: inventorySummaryReportSlice.reducer,
  usersReports: usersReportSlice.reducer,
  salesReports: salesReportSlice.reducer,
  transactionsReports: transactionsReportSlice.reducer,
  merchantStoresReports: merchantStoresReportSlice.reducer,
  merchantStoreSummaryReports: merchantStoreSummaryReportSlice.reducer,
  inventoryTransactionReports: inventoryTransactionReportSlice.reducer,
});

export const rootReducer = (state, action) => {
  if (action.type === auth.actionTypes.Logout) {
    const { auth } = state;

    return appReducer({ auth }, action);
  }
  return appReducer(state, action);
};

export function* rootSaga() {
  yield all([auth.saga()]);
}
